import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';
import moment from 'moment/moment';

import PageHeader from 'components/common/PageHeader';
import DataCard from 'components/mycomponents/DataCard';
import ModalAlert from 'components/mycomponents/ModalAlert';

import Config from 'utils/config';

import Data from './Data';
import Detail from './Detail';

const BusReport = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [dataDetail, setDataDetail] = useState(null);
    const [busSelected, setBusSelected] = useState('');
    const [showDetail, setShowDetail] = useState(false);
    const [keyword, setKeyword] = useState({q:'', reportTime:1, reportMonth: moment().format('M'), reportYear: moment().format('YYYY'), fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD')});
    const [keywordShow, setKeywordShow] = useState({q: true, reportTime: false, reportMonth: false, reportYear: false, fromDate: false, toDate: false});
    const [pagination, setPagination] = useState({disabledPrev: true, disabledNext: false, pageTotal: 0, currentPage: 1, limit: 10, numberStart: 0});
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataDetail, setLoadingDataDetail] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false, actionType: '', actionId: null});

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/bus/reservation';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

    // function get data
    const getData = async (page = 1, limit = 10) => {
        setLoadingData(true);
        let fromDate = keyword.fromDate;
        let toDate = keyword.toDate;
        if (keyword.reportTime === '3') {
            fromDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).format('YYYY-MM-DD');
            toDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).endOf('month').format('YYYY-MM-DD');
        }
        try {
            const response = await axios.get(`${DATA_URL}?q=${keyword.q}&from=${fromDate}&to=${toDate}&page=${page}&limit=${limit}`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            const responseDataLength = responseResult?.length;
            const responseDataPageTotal = responseResult?.page_total;

            if (responseDataLength > 0) {
                setData(responseData);
                setPagination(prevState => {
                    return {...prevState, pageTotal: responseDataPageTotal, limit: limit, currentPage: page, numberStart: limit * (page - 1)}
                })
            } else {
                setData(null);
            }
            if (page >= responseDataPageTotal) {
                setPagination(prevState => {
                    return {...prevState, disabledNext: true}
                })
            } else {
                setPagination(prevState => {
                    return {...prevState, disabledNext: false}
                })
            }
            if (page === 1) {
                setPagination(prevState => {
                    return {...prevState, disabledPrev: true}
                })
            }
            setLoadingData(false);
            
        } catch (err) {
            setLoadingData(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const reportTimeParam = urlParams.get('rt');
        const reportMonthParam = urlParams.get('m');
        const reportYearParam = urlParams.get('y');

        const keywordValue = keywordParam ? keywordParam : '';
        const fromDateValue = fromDateParam ? fromDateParam : moment().format('YYYY-MM-DD');
        const toDateValue = toDateParam ? toDateParam : moment().format('YYYY-MM-DD');
        const reportTimeValue = reportTimeParam ? reportTimeParam : 1;
        const reportMonthValue = reportMonthParam ? reportMonthParam : moment().format('M');
        const reportYearValue = reportYearParam ? reportYearParam : moment().format('YYYY');

        if (reportTimeValue === '1') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: false}
            })
        }
        if (reportTimeValue === '2') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: true}
            })
        }
        if (reportTimeValue === '3') {
            setKeywordShow(prevState => {
                return {...prevState, reportMonth: true, reportYear: true, fromDate: false, toDate: false}
            })
        }

        let keywordTemp = keyword;
        keywordTemp.q = keywordValue
        keywordTemp.fromDate = fromDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.reportTime = reportTimeValue
        keywordTemp.reportMonth = reportMonthValue
        keywordTemp.reportYear = reportYearValue
        setKeyword(keywordTemp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // Toggle Form to open and close modal detail
    const handleToggleDetail = () => {
        setShowDetail(!showDetail);
    }

    const handleDetail = async (intid) => {
        const selectData = data ? data.find(data => parseFloat(data.intid) === parseFloat(intid)) : null;
        const busName = selectData ? selectData.vcnama : '';
        setBusSelected(busName);

        setLoadingDataDetail(true);
        try {
            const response = await axios.get(`${DATA_URL}/${intid}`, HEADER_AUTHORIZATION);
            const responseData = response?.data;
            const responseDataResult = responseData?.data;
            
            setDataDetail(responseDataResult)
            setShowDetail(true);
            setLoadingDataDetail(false);
        } catch (err) {
            setLoadingDataDetail(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleUpdateStatus = async (status, intid) => {
        setShowAlert(prevState => { return {...prevState, show: false, message: '', type: '', confirmButton: false, actionType: '', actionId: null} });
        try {
            const response = await axios.put(`${DATA_URL}/${intid}/${status}`, null, HEADER_AUTHORIZATION);
            const responseData = response?.data;            
            
            if (responseData) {
                toast.success(responseData.message);
                getData(pagination.currentPage, pagination.limit);
                setShowDetail(false);
            }
        } catch (err) {
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleAction = (type, intid) => {
        if (type === 'approve') {
            setShowAlert(prevState => { return {...prevState, show: true, message: 'Apakah anda yakin untuk menyetujui data ini?', type: 'confirm', confirmButton: true, actionType: 'approveOK', actionId: intid} });
        }
        if (type === 'reject') {
            setShowAlert(prevState => { return {...prevState, show: true, message: 'Apakah anda yakin untuk menolak data ini?', type: 'confirm', confirmButton: true, actionType: 'rejectOK', actionId: intid} });
        }
        
        if (type === 'approveOK' || type === 'rejectOK') {
            const status = type === 'approveOK' ? 1 : 2;
            handleUpdateStatus(status, intid);
        }
    }

    const handleChangeForm = (event, state = '') => {
        const {value, name} = event.target;
        if (state === 'keyword') {
            setKeyword(prevState => {
                return {...prevState, [name]: value};
            })
            if (name === 'reportTime') {
                if (value === '1') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: false}
                    })
                }
                if (value === '2') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: false, reportYear: false, fromDate: true, toDate: true}
                    })
                }
                if (value === '3') {
                    setKeywordShow(prevState => {
                        return {...prevState, reportMonth: true, reportYear: true, fromDate: false, toDate: false}
                    })
                }
            }
        } else if (name === 'limit') {
            setPagination(prevState => {
                return {...prevState, limit: value}
            })
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate)
            getData(1, value)
        }
    }

    const handleChangeDate = (value, name) => {
        setKeyword(prevState => {
            return {...prevState, [name]: moment(value).format('YYYY-MM-DD')};
        })
        if (name === 'fromDate') {
            const fromDateTemp = moment(value).format('YYYY-MM-DD');
            const toDateTemp = moment(keyword.toDate).format('YYYY-MM-DD');
            if (fromDateTemp > toDateTemp) {
                setKeyword(prevState => {
                    return {...prevState, toDate: moment(value).format('YYYY-MM-DD')};
                })
            }
        }
        if (name === 'toDate') {
            const fromDateTemp = moment(keyword.fromDate).format('YYYY-MM-DD');
            const toDateTemp = moment(value).format('YYYY-MM-DD');
            if (fromDateTemp > toDateTemp) {
                setKeyword(prevState => {
                    return {...prevState, fromDate: moment(value).format('YYYY-MM-DD')};
                })
            }   
        }
    }

    const handleSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const page = 1;
        const keywordSearch = keyword.q;
        const keywordFromDate = moment(keyword.fromDate).format('YYYY-MM-DD');
        const keywordToDate = moment(keyword.toDate).format('YYYY-MM-DD');
        const keywordReportTime = keyword.reportTime;
        const keywordReportMonth = keyword.reportMonth;
        const keywordReportYear = keyword.reportYear;
        const pathUrl = window.location.pathname;
        let urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${keywordReportTime}&from=${keywordFromDate}&to=${keywordToDate}&page=${page}`
        if (keywordReportTime === '3') {
            urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${keywordReportTime}&from=${keywordFromDate}&to=${keywordToDate}&m=${keywordReportMonth}&y=${keywordReportYear}&page=${page}`
        }
        navigate(urlNavigate)
        getData(page)
    }

    const handleClickPagination = (type) => {
        let count = 0;
        if (type === 'prev') {
            count = -1
        }
        if (type === 'next') {
            count = 1
        }

        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const pageParam = urlParams.get('page');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const reportTimeParam = urlParams.get('rt');
        const reportMonthParam = urlParams.get('m');
        const reportYearParam = urlParams.get('y');

        const page = pageParam ? parseFloat(pageParam) + count : 2;
        const keywordSearch = keywordParam ? keywordParam : keyword.q;
        const fromDateValue = fromDateParam ? fromDateParam : keyword.fromDate;
        const toDateValue = toDateParam ? toDateParam : keyword.toDate;
        const reportTimeValue = reportTimeParam ? reportTimeParam : keyword.reportTime;
        const reportMonthValue = reportMonthParam ? reportMonthParam : keyword.reportMonth;
        const reportYearValue = reportYearParam ? reportYearParam : keyword.reportYear;
        const pathUrl = window.location.pathname;

        if (page > 1) {
            setPagination(prevState => {
                return {...prevState, disabledPrev: false}
            })
        } else {
            setPagination(prevState => {
                return {...prevState, disabledPrev: true}
            })
        }

        let urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${reportTimeValue}&from=${fromDateValue}&to=${toDateValue}&page=${page}`;
        if (reportTimeValue === '3') {
            urlNavigate = `${pathUrl}?q=${keywordSearch}&rt=${reportTimeValue}&from=${fromDateValue}&to=${toDateValue}&m=${reportMonthValue}&y=${reportYearValue}&page=${page}`
        }
        navigate(urlNavigate)
        getData(page, pagination.limit)
    }

    const handleConfirmAlert = () => {
        console.log(showAlert.actionType);
        
        if (showAlert.actionType === 'approveOK' || showAlert.actionType === 'rejectOK') {
            handleAction(showAlert.actionType, showAlert.actionId);
        } else {
            setShowAlert(prevState => { return {...prevState, show: false}});
        }
    }

    const handleClickExport = () => {
        let fromDate = keyword.fromDate;
        let toDate = keyword.toDate;
        if (keyword.reportTime === '3') {
            fromDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).format('YYYY-MM-DD');
            toDate = moment(`${keyword.reportYear}-${keyword.reportMonth}-01`).endOf('month').format('YYYY-MM-DD');
        }
        window.open(`${Config.baseUrlApi}/report/bus/export?q=${keyword.q}&from=${fromDate}&to=${toDate}`, '_blank');
        // window.open(Config.baseUrlApi + '/report/bus/export/' + keyword.fromDate, '_blank')
    }

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Resrvasi Bus"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <DataCard>
                <DataCard.HeaderReport 
                    title={''} 
                    keywordShow={keywordShow}
                    keyword={keyword} 
                    handleChangeKeyword={handleChangeForm} 
                    handleSearch={handleSearch} 
                    handleChangeDate={handleChangeDate}
                    handleClickExport={handleClickExport} />
                <DataCard.Body>
                    <Data 
                        dataMain={data}
                        actionDetail={handleDetail} 
                        numberStart={pagination.numberStart} 
                        isLoading = {loadingData}
                    />
                    <Row>
                        <Col sm={2}>
                            <Form.Select
                                name="limit"
                                value={pagination.limit}
                                onChange={handleChangeForm}
                            >
                                <option value={10}>10 Baris</option>
                                <option value={20}>20 Baris</option>
                                <option value={30}>30 Baris</option>
                            </Form.Select>
                        </Col>
                        <Col sm={10}>
                            <div className="float-end">
                                <Button variant="primary" size="sm" disabled={pagination.disabledPrev} onClick={() => handleClickPagination('prev')} className="me-2">Sebelumnya</Button>
                                <Button variant="primary" size="sm" disabled={pagination.disabledNext} onClick={() => handleClickPagination('next')}>Selanjutnya</Button>
                            </div>
                        </Col>
                    </Row>
                </DataCard.Body>
            </DataCard>

            {/* Detail Data */}
            <Detail 
                show={showDetail}
                handleClose={handleToggleDetail}
                data={dataDetail}
                busName={busSelected}
                date={keyword.fromDate}
                loadingDataDetail={loadingDataDetail}
                handleAction={handleAction}
            />

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

BusReport.propTypes = {}

export default BusReport;